import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Input, Divider, Form } from 'antd';
import { _success, _setAxios, _validationFormMsg } from '../../../../lib/Helper';
import SelectJenisDocLembaga from '../../../../components/select/SelectJenisDocLembaga';
import { UploadFile } from '../../../../components/upload-files';

const { TextArea } = Input;

let schema = {
    jenis: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    nama: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    file: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,

            visible: false,
        };
    }

    componentDidMount() {
        const data = this.props.data
        this.setState({
            values: {
                ...data,
                file: null
            },
        })

        if(data.id){
            schema.file = null
        }
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        const errors = validate(values, schema);
        if (errors) {
            return _validationFormMsg(errors)
        }
        this.setState({
            loading: true
        });
        const params = {
            jenis: values.jenis ? values.jenis : null,
            nama: values.nama ? values.nama : null,
            nomor: values.nomor ? values.nomor : null,
            keterangan: values.keterangan ? values.keterangan : null,
            file: values.file ? values.file : null,
        }

        let endpoint = "lembaga/dokumen"
        let method = "POST"
        if (values.id) {
            endpoint = "lembaga/dokumen/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {
        const { data } = this.props

        return (
            <Modal
                maskClosable={false}
                title={"Form Dokumen Lembaga"}
                open={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={null}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={this.handleSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <Form.Item label="Jenis dokumen *">
                                <SelectJenisDocLembaga
                                    defaultValue={data.jenis}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("jenis", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Nama *">
                                <Input
                                    name="nama"
                                    placeholder="Nama dokumen"
                                    defaultValue={data.nama}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("nama", e.target.value)
                                    }} />
                            </Form.Item>
                            <Form.Item label="Nomor">
                                <Input
                                    name="nomor"
                                    placeholder="Nomor dokumen"
                                    defaultValue={data.nomor}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("nomor", e.target.value)
                                    }} />
                            </Form.Item>
                            <Form.Item label="Keterangan">
                                <TextArea
                                    rows={2}
                                    placeholder="Keterangan"
                                    defaultValue={data.keterangan}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("keterangan", e.target.value)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="File *">
                                <UploadFile
                                    isValidation={true}
                                    type="jpg, png & pdf"
                                    onChange={(val) => {
                                        this.handleChangeSetValue("file", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} style={{ textAlign: "right" }}>
                            <Divider />
                            <Button onClick={this.props.hideModal}>Batal</Button> &nbsp;
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>Simpan</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default FormContent;
